// Module
var code = `<div class="form-group {{form.htmlClass}} schema-form-select"
     ng-class="{
      'has-error': form.disableErrorState !== true && hasError(),
      'has-success': form.disableSuccessState !== true && hasSuccess(),
      'has-feedback': form.feedback !== false
      }">
  <label class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()">
    {{form.title}}
  </label>
    <div
            amt-json-editor
            sf-field-model
            options="{
                name: form.json_editor_name || form.key,
                mode: form.json_editor_mode || 'tree',
                schema: form.json_editor_schema,
            }"
            style="height: {{form.json_editor_height}}px;"
    ></div>
  <div class="help-block" sf-message="form.description"></div>
</div>
`;
// Exports
module.exports = code;